<template>
<div>
  <div class="map-search">
    <span class="middle-y"></span>
    <input class="middle-y" @keydown.enter="handleSearch" type="text" v-model="word" placeholder="请输入关键词搜索">
    <b class="middle-y" @click="handleClose"></b>
  </div>
  <div class="article-list">
    <div class="subtit banxin">
      搜索结果
    </div>
    <div class="total banxin">{{total}}条结果</div>
    <div class="group">
      <ul>
        <li v-for="(item, i) in group" :key="i" @click="handleClick(item)">
          <div class="banxin">
            {{item.title}}
          </div>
        </li>
      </ul>
      <Page class="mypage" v-if="total > 10" :total="total" show-elevator :page-size="psize" :current="page" @on-change="handleChange"/>
    </div>
  </div>
</div>
</template>
<script>
import { Page } from "iview"
export default {
  components: {Page},
  data() {
    return {
      word: '',
      page: 1,
      psize: 10,
      group: [],
      total: 0
    }
  },
  methods: {
    handleSearch() {
      this.page = 1
      this.group = []
      this.hanldeGetData()
    },
    hanldeGetData() {
      this.$store.dispatch('getSearchResult', {page: this.page, psize: this.psize, title: this.word})
      .then((res) => {
        this.group = res.data
        this.total = res.total
      }) 
    },
    handleClose() {
      this.$router.go(-1)
    },
    handleChange(page) {
      this.page = page
      this.hanldeGetData()
    },
    handleClick(obj) {
      if(obj.type === 1) {
        this.$router.push('/Home/Article/' + obj.id)
      }else if (obj.type === 2) {
        this.$router.push('/Home/LeaderInfo/' + obj.id)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.map-search {
  width: 100%;
  top: 0;
  height: 3.5rem;
  background: #FFFFFF;
  box-shadow: 0 0 4px rgba(0, 0, 0, .4);
  position: fixed;
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
  padding-left: 3.5rem;
  span {
    width: 1.2rem;
    height: 1.2rem;
    position: absolute;
    left: 1.5rem;
    background: url('../assets/imgs/images/search2.png') no-repeat center/contain;
  }
  input {
    border: 0 none;
    outline: 0 none;
    left: 3.5rem;
    color: rgba(151, 151, 151, 1);
    font-weight: 700;
    width: 80rem;
    &::placeholder {
      color: #CCCCCC;
    }
  }
  b {
    right: 1.5rem;
    width: 0.8rem;
    height: 0.8rem;
    cursor: pointer;
    background: url('../assets/imgs/images/close.png') no-repeat center/contain;
  }
}
.map-search.act {
  width: 91.95rem;
  top: 2rem;
}
.article-list {
  padding-top: 4rem;
  .subtit {
    border-bottom: 1px solid #eee;
    line-height: 3.5rem;
    color: #333333;
    font-size: 1.2rem;
  }
  .total {
    color: #999999;
    margin-top: 1rem;
  }
  .group {
    min-height: 13.5rem;
    ul {
      padding-top: 1rem;
      li {
        border-bottom: 1px solid #eee;
        cursor: pointer;
        .banxin {
          height: 2.45rem;
          line-height: 2.45rem;
          font-size: 0.8rem;
          padding-left: 1rem;
          box-sizing: border-box;
        }
      }
      li:hover {
        background: rgba(54, 143, 254, .1)
      }
    }
    .mypage {
      margin: 0 auto;
      text-align: center;
    }
  }
}
</style>


